import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-confirm-dialog',
  imports: [MatButtonModule, MatDialogModule, MatIconModule],
  template: `
    <div class="dialog-header">
      <mat-icon class="dialog-back" [mat-dialog-close]="false">chevron_left</mat-icon>
      <span class="dialog-title">{{ data.title }}</span>
      <mat-icon class="dialog-close" [mat-dialog-close]="false">close</mat-icon>
    </div>
    <div class="dialog-body" style="text-align: center;">
      <p>{{ data.message }}</p>
    </div>
    <div class="dialog-footer">
      <button class="dialog-save-btn" style="background-color: var(--accent);" [mat-dialog-close]="true">
        {{ data.confirmText || 'Löschen' }}
      </button>
    </div>
  `
})
export class ConfirmDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: { title: string, message: string, confirmText?: string }) {}
}
